<template>
    <div class="content">
        <TopBar barTheme="white" :barStyle="`background: url(${require('@/assets/images/personal_top_bg.png')}) no-repeat; background-size: 100%;`">
            <span class="page-title" slot="title">积分明细</span>
        </TopBar>
        <div class="integral">
            <div class="personal-info">
                <div class="current-integral">
                    <p>有效积分</p>
                    <h3><i class="number-font">{{ info.userPoint }}</i></h3>
                </div>
                <div class="integral-tip hvc" v-if="info.expirePoint > 0">
                    <p>即将过期：{{info.expirePoint}}</p>
                    <i class="icon icon-line"></i>
                    <p>有效期至：{{info.pointExpireDateStr}}</p>
                </div>
                <div class="freeze-point vc" @click="showTip" v-if="info.freezePoint">
                    冻结积分 {{info.freezePoint}}
                    <i class="icon icon-question"></i>
                </div>
                <div class="recommend-tips">
                    <router-link to="/recommend/courtesy">赚更多积分</router-link>
                </div>
                <div class="message-layer" @click.self="closeMsg" v-if="msgShow">
                    <div class="message-content">
                        <div class="msg-text">
                            <h3>{{msgTitle}}</h3>
                            <div class="msg-tip hvc" v-html="msgTip"></div>
                        </div>
                        <div class="bottom-btn">
                            <a class="btn-item btn-close hvc" href="javascript: void(0)" @click="closeMsg">我知道了</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="integral-list">
                <div class="list-hd wrap">
                    <ul class="tab-box">
                        <li :class="`hvc ${activeIndex === 0 ? 'cur' : ''}`" @click="changeTab(0)">全部</li>
                        <li :class="`hvc ${activeIndex === 1 ? 'cur' : ''}`" @click="changeTab(1)">获得</li>
                        <li :class="`hvc ${activeIndex === 2 ? 'cur' : ''}`" @click="changeTab(2)">消耗</li>
                    </ul>
                </div>
                <div class="list-bd">
                    <div class="show-box wrap" v-if="this.integralList.length > 0">
                        <ul>
                            <li :class="`${item.changeValue > 0 ? 'type-increase' : 'type-decrease'} vc`" v-for="(item, index) in integralList" :key="index">
                                <div class="point-des">
                                    <div class="des-item list-type vc">
                                        <p>{{item.comments}}</p>
                                        <div class="vc" v-if="item.remarks">
                                            <i class="icon icon-line-black"></i>
                                            <p>{{item.remarks}}</p>
                                        </div>
                                    </div>
                                    <div class="des-item transaction-number vc" v-if="item.outsideOrderNumber">
                                        <p>关联单号：{{item.outsideOrderNumber}}</p>
                                    </div>
                                    <div class="des-item time-tip vc">
                                        <p>交易日期：{{item.creationDateStr}}</p>
                                        <div class="vc" v-if="item.expireDateStr">
                                            <i class="icon icon-line-black"></i>
                                            <p>有效期至：{{item.expireDateStr}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="point-num">{{item.changeValue}}</div>
                            </li>
                        </ul>
                    </div>
                    <infinite-loading @infinite="infiniteHandler" ref="infiniteLoading" :identifier="thisIdentifier">
                        <span slot="no-more"></span>
                        <div class="blank-tip" slot="no-results">
                            <div class="tip-box">
                                <i class="icon icon-blank"></i>
                                <p>您还没有消耗任何积分哦！</p>
                                <a class="btn-item btn-obtain hvc" @click="goPage">去兑换</a>
                            </div>
                        </div>
                    </infinite-loading>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from '@/libs/api.request'
    import InfiniteLoading from 'vue-infinite-loading'
    import TopBar from '@/components/top-bar/'
    export default {
        name: 'integralList',
        components: {
            TopBar,
            InfiniteLoading
        },
        data: () => {
            return {
                info: {},
                pageSize: 10,
                pageIndex: 1,
                searchType: 0,
                isLoading: 0, // 正在加载状态值
                thisIdentifier: Date.now(),
                toUrl: '/',
                integralList: [],
                activeIndex: 0,
                msgShow: false,
                msgTitle: '温馨提示',
                msgTip: '冻结积分包含通过船票预订、推荐<br>有礼等方式获得的待发放的积分'
            }
        },
        created () {},
        mounted () {
            this.getUserPoint()
                .then(res => {
                    this.info = res
                })
        },
        methods: {
            showTip () {
                this.msgShow = true
            },
            closeMsg () {
                this.msgShow = false
            },
            getUserPoint () {
                return new Promise(resolve => {
                    axios.request({
                        url: '/api/CustomerInfo/ApiGetUserPoint',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: {
                            loyaltyId: this.$store.state.user.loyaltyId
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            infiniteHandler ($state) {
                this.isLoading = 1
                axios.request({
                    url: '/api/CustomerInfo/ApiGetUserPointLog',
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.$store.state.user.token}`
                    },
                    data: {
                        loyaltyId: this.$store.state.user.loyaltyId,
                        searchType: this.searchType,
                        pageSize: this.pageSize,
                        pageIndex: this.pageIndex
                    }
                })
                    .then(res => {
                        let data = res.data
                        if (data.errCode === 0) {
                            this.isLoading = 0
                            let rows = data.data.rows
                            if (rows.length > 0) {
                                this.integralList = [...this.integralList, ...rows]
                                $state.loaded()
                                this.pageIndex += 1
                            } else {
                                $state.complete()
                            }
                        } else if (data.errCode === 1000) {
                            window.console.log('失败')
                        } else {
                            window.console.log('系统错误')
                        }
                    })
                    .catch(err => {
                        window.console.log(err)
                    })
            },
            changeTab (index) {
                if (this.isLoading) return false
                this.activeIndex = index
                this.integralList = []
                this.pageIndex = 1
                if (index === 0) {
                    this.searchType = 0
                    this.toUrl = '/'
                }
                if (index === 1) {
                    this.searchType = 10
                    this.toUrl = '/'
                }
                if (index === 2) {
                    this.searchType = 20
                    this.toUrl = '/member/shop/index'
                }
                this.thisIdentifier = Date.now() // 子组件监听本属性进行重载
            },
            goPage () {
                if (this.searchType === 20) {
                    this.$router.push(this.toUrl)
                } else {
                    window.location.href = '/'
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .page-title{
        color: #fff;
    }
    .integral{
        .personal-info{
            height: 3.30rem;
            padding-top: 1.24rem;
            background: url("../../../assets/images/personal_top_bg.png") no-repeat;
            background-size: 100%;
            color: #fff;
            .current-integral{
                text-align: center;
                p{
                    line-height: 1;
                }
                h3{
                    margin-top: 0.06rem;
                    font-size: 0.46rem;
                    line-height: 1;
                }
            }
            .integral-tip{
                height: 0.52rem;
                padding-top: 0.28rem;
                .icon-line{
                    width: 0.02rem;
                    height: 0.26rem;
                    margin: 0 0.16rem;
                    background-color: #fff;
                }
            }
            .freeze-point{
                justify-content: flex-end;
                -webkit-justify-content: flex-end;
                position: absolute;
                right: 0.30rem;
                top: 1.58rem;
                height: 0.38rem;
                padding-right: 0.05rem;
                padding-left: 0.32rem;
                border-radius: 0.19rem;
                background-color: #00b4da;
                .icon-question{
                    width: 0.28rem;
                    height: 0.28rem;
                    margin-left: 0.10rem;
                    background: url("../../../assets/images/icon_question_2.png") no-repeat;
                    background-size: 100% 100%;
                }
            }
            .recommend-tips {
                text-align: center;
                margin: 10px 0px;
                a {
                    text-decoration: underline;
                }
            }
            .message-layer .message-content{
                width: 4.00rem;
                height: 2.98rem;
            }
            .message-layer .msg-text h3{
                font-size: 0.33rem;
                font-weight: normal;
                color: #febc10;
            }
            .message-layer .msg-tip{
                padding-top: 0.30rem;
                font-size: 0.24rem;
                line-height: 0.38rem;
                color: #333;
            }
            .message-layer .btn-close{
                color: #333;
            }
        }
        .integral-list{
            .list-hd{
                height: 0.91rem;
                border-bottom: #d4dbde solid 0.02rem;
                background-color: #fff;
                .tab-box{
                    display: flex;
                    display: -webkit-flex;
                    justify-content: space-between;
                    -webkit-justify-content: space-between;
                    height: 100%;
                    li{
                        width: 1.44rem;
                        height: 0.91rem;
                        padding-top: 0.06rem;
                        padding-bottom: 0.06rem;
                        font-size: 0.30rem;
                        &.cur{
                            padding-bottom: 0;
                            border-bottom: #4a90e2 solid 0.06rem;
                            color: #4a90e2;
                        }
                    }
                }
            }
            .list-bd{
                .show-box{
                    padding-bottom: 0.90rem;
                }
                ul{
                    li{
                        justify-content: space-between;
                        -webkit-justify-content: space-between;
                        padding: 0.30rem 0;
                        .point-des{
                            color: #747d80;
                            .des-item{
                                height: 0.34rem;
                            }
                            .icon-line-black{
                                width: 0.02rem;
                                height: 0.26rem;
                                margin: 0 0.16rem;
                                background-color: #747d80;
                            }
                            .list-type{
                                .icon-line-black{
                                    margin: 0 0.08rem;
                                }
                            }
                        }
                        .point-num{
                            font-size: 0.30rem;
                            font-weight: bold;
                        }
                        &.type-increase{
                            .point-num{
                                color: #ffa70d;
                                &::before{
                                    content: "+";
                                }
                            }
                        }
                        &.type-decrease{
                            .point-num{
                                color: #4a90e2;
                            }
                        }
                    }
                }
                .blank-tip{
                    height: calc(100vh - 3.00rem - 0.91rem);
                    padding-top: 1.74rem;
                    background-color: #f6f7f8;
                    .tip-box{
                        width: 4.00rem;
                        margin: 0 auto;
                        text-align: center;
                        .icon-blank{
                            width: 2.03rem;
                            height: 1.73rem;
                            background: url("../../../assets/images/blank.png") no-repeat;
                            background-size: 100% 100%;
                        }
                        p{
                            margin-top: 0.30rem;
                            color: #919b9f;
                            line-height: 1;
                        }
                        .btn-obtain{
                            display: flex;
                            display: -webkit-flex;
                            width: 2.75rem;
                            height: 0.60rem;
                            margin: 0.30rem auto 0;
                            background-color: #fbc500;
                            border-radius: 0.30rem;
                        }
                    }
                }
            }
        }
    }
</style>
